import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class SettingsNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the deleteAllUnusedCustomCouponCodes global action. */
    this.deleteAllUnusedCustomCouponCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deleteAllUnusedCustomCouponCodes",
      operationName: "deleteAllUnusedCustomCouponCodes",
      operationReturnType: "SettingsDeleteAllUnusedCustomCouponCodes",
      namespace: "settings",
      variables: {
        customerId: { required: false, type: "String" },
        categoryFilter: { required: false, type: "String" }
      }
    });
    /** Executes the deleteCouponCodes global action. */
    this.deleteCouponCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deleteCouponCodes",
      operationName: "deleteCouponCodes",
      operationReturnType: "SettingsDeleteCouponCodes",
      namespace: "settings",
      variables: {
        customerId: { required: false, type: "String" },
        category: { required: false, type: "String" }
      }
    });
    /** Executes the exportCouponCodes global action. */
    this.exportCouponCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportCouponCodes",
      operationName: "exportCouponCodes",
      operationReturnType: "SettingsExportCouponCodes",
      namespace: "settings",
      variables: {
        customerId: { required: false, type: "String" },
        category: { required: false, type: "String" }
      }
    });
    /** Executes the importCouponCodes global action. */
    this.importCouponCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importCouponCodes",
      operationName: "importCouponCodes",
      operationReturnType: "SettingsImportCouponCodes",
      namespace: "settings",
      variables: {
        customerId: { required: false, type: "String" },
        codes: { required: false, type: "[String!]" },
        category: { required: false, type: "String" }
      }
    });
    /** Executes the importCouponCodesController global action. */
    this.importCouponCodesController = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importCouponCodesController",
      operationName: "importCouponCodesController",
      operationReturnType: "SettingsImportCouponCodesController",
      namespace: "settings",
      variables: {
        customerId: { required: false, type: "String" },
        codes: { required: false, type: "[String!]" },
        category: { required: false, type: "String" }
      }
    });
    /** Executes the searchCouponCodes global action. */
    this.searchCouponCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "searchCouponCodes",
      operationName: "searchCouponCodes",
      operationReturnType: "SettingsSearchCouponCodes",
      namespace: "settings",
      variables: {
        customerId: { required: false, type: "String" },
        category: { required: false, type: "String" },
        first: { required: false, type: "Float" },
        after: { required: false, type: "String" },
        before: { required: false, type: "String" },
        last: { required: false, type: "Float" }
      }
    });
    /** Executes the csvImportUpdateProgression global action. */
    this.csvImportUpdateProgression = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "csvImportUpdateProgression",
      operationName: "csvImportUpdateProgression",
      operationReturnType: "SettingsCsvImportUpdateProgression",
      namespace: "settings",
      variables: {
        csvImportId: { required: false, type: "String" },
        tagId: { required: false, type: "String" }
      }
    });
    /** Executes the importCsvContacts global action. */
    this.importCsvContacts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "importCsvContacts",
      operationName: "importCsvContacts",
      operationReturnType: "SettingsImportCsvContacts",
      namespace: "settings",
      variables: { csvImportId: { required: false, type: "String" } }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "settings",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  SettingsNamespace
};
//# sourceMappingURL=settings.js.map
